import { motion } from 'framer-motion';
import { useCallback, useEffect, useState } from 'react';
import removeAccents from 'remove-accents';

import InputSearch from '../InputSearch';
import { Paginator } from '../Paginator';

import { ItemAssistant } from './ItemsAssistant';

import { useIsDesktop } from '@/hooks/useIsDesktop';
import { VallasInvictasClub } from '@/types/fieldAssistance';
import { VariantFieldAssistance } from '@/types/team';
import { FADE_IN_OUT, cn } from '@/utils';

interface Props extends VariantFieldAssistance {
  teams: VallasInvictasClub[];
}

export const InvictusTable = ({ teams, variant = 'DEFAULT' }: Props) => {
  const [state, setState] = useState<{
    team: VallasInvictasClub[];
    term: string;
  }>({
    team: teams,
    term: '',
  });
  const { isMobile } = useIsDesktop();

  const handleContentCurrentPage = (teamsByPaginator: VallasInvictasClub[]) => {
    teams && setState({ ...state, team: teamsByPaginator });
  };

  const listBySearch = useCallback(
    (term: string) => {
      const teamsBySearch = teams.filter((team) => {
        const querySearch = term.toLowerCase();
        const nameClub = removeAccents(team.nombreClub).toLowerCase();
        return nameClub.includes(querySearch);
      });

      return teamsBySearch;
    },
    [teams]
  );

  useEffect(() => {
    const list = listBySearch(state.term);
    if (state.term !== '') {
      setState({ ...state, team: list });
    }
    if (list && isMobile) {
      setState({ ...state, team: list });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMobile, listBySearch, state.term]);

  return (
    teams &&
    teams.length > 0 && (
      <motion.div animate={'show'} initial={'hide'} variants={FADE_IN_OUT}>
        <div
          className={cn('w-full bg-white mt-3 lg:mt-6 rounded-lg', {
            'h-screen': variant === 'EMBED',
          })}
        >
          <div className="lg:pt-4 lg:px-6 pt-0 px-4 pb-4 bg-gdt-gray-7 lg:bg-white lg:rounded-lg lg:overflow-hidden">
            <InputSearch
              handleCancel={() => setState({ ...state, term: '' })}
              name="search-club"
              onlyLetters={true}
              placeholder="Buscar club"
              value={state.term}
              onChange={(event) => {
                setState({ ...state, term: event.target.value });
              }}
            />
          </div>
          {isMobile ? (
            <div
              className={cn({
                'overflow-auto h-[calc(100vh-240px)]': variant === 'EMBED',
              })}
            >
              {state.team.map((team: VallasInvictasClub, index: number) => {
                return (
                  <ItemAssistant.Invictus
                    key={team.nombreClub}
                    index={index}
                    team={team}
                  />
                );
              })}
            </div>
          ) : (
            <>
              {state.team.map((team: VallasInvictasClub, index: number) => {
                return (
                  <ItemAssistant.Invictus
                    key={team.nombreClub}
                    index={index}
                    team={team}
                  />
                );
              })}
              {(state.team.length >= 10 || state.term === '') && (
                <Paginator
                  currentContentPage={handleContentCurrentPage}
                  items={teams}
                />
              )}
            </>
          )}
        </div>
      </motion.div>
    )
  );
};
